import {MonitoringServer} from "@/lib/types/monitoring.ts";

export enum RunTestTaskStatus {
  NEW = "NEW",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export interface MetaData {
  hostname: string;
  addresses: string[];
}

export interface TestResult {
  status: RunTestTaskStatus;
  result: string;
  monitoring_server: MonitoringServer;
  meta?: MetaData;
}
